import { Navigate } from 'react-router';
import { route, useAuthBootstrap } from '@hero/web-hooks';

interface PublicOnlyRouteProps {
  children: React.ReactNode;
}

export default function PublicOnlyRoute({ children }: PublicOnlyRouteProps) {
  const { isBootstrapping, isLoggedIn } = useAuthBootstrap();

  // Wait for the boot-time silent refresh so an already-signed-in
  // user isn't briefly shown the login screen after a hard reload.
  if (isBootstrapping) {
    return (
      <div className="min-h-screen bg-muted flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (isLoggedIn) {
    return <Navigate to={route('dashboard')} replace />;
  }

  return <>{children}</>;
}
